export default "https://cdn-static.gokick.com/assets/faf4ec4796b5499b7477edf17656e3681d9dd642/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";